import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { InvoiceService } from '../../../services/accounting/invoice.service';
import { NotyService } from '../../../services/common/noty.service';
import { AuthService } from '../../../services/common/auth.service';

@Component({
  selector: 'app-matter-invoice-index',
  templateUrl: './matter-invoice-index.component.html',
  styleUrls: ['./matter-invoice-index.component.css'],
})
export class MatterInvoiceIndexComponent implements OnInit {
  @Input() matter_id: number;

  search_options: any = {};

  count: number = 0;

  search_params: any = {
    page: 1,
    per_page: 30,
  };

  invoices: Array<any> = [];

  loading: boolean = true;

  constructor(
    private invoiceService: InvoiceService,
    private notyService: NotyService,
    public authService: AuthService
  ) {}

  // Component lifecycle events
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue)
      this.invoiceService.getSearchOptions().then((response_json) => {
        this.search_options = response_json;
        this.search_params.per_page = response_json.per_page;
        this.loadInvoices();
      });
  }

  // Component methods
  loadInvoices(pageEvent: any = null) {
    if (pageEvent) this.search_params.page = pageEvent.page;
    this.search_params.matter_id = this.matter_id;
    this.invoiceService.getInvoices(this.search_params).then((response_json) => {
      this.count = response_json.count;
      this.invoices = response_json.invoices;
      this.loading = false;
    });
  }

  markPaid(invoice: any) {
    if (invoice.is_paid || invoice.actionInProgress) return;

    if (!confirm(`Are you sure you want to mark Invoice #${invoice.id} as paid?`)) return;

    invoice.actionInProgress = true;
    this.invoiceService.markInvoicePaid(invoice.id).then(response => {
      invoice.actionInProgress = false;
      if (response.success) {
        invoice.is_paid = true;
        invoice.paid_at = new Date().toISOString();
        this.notyService.notify(response.message, 'success');
      } else {
        this.notyService.notify(response.message || 'Failed to mark invoice as paid', 'error');
      }
    }).catch(error => {
      invoice.actionInProgress = false;
      this.notyService.notify('Error marking invoice as paid', 'error');
      console.error('Error marking invoice as paid:', error);
    });
  }

  withdrawInvoice(invoice: any) {
    if (invoice.actionInProgress) return;

    if (!confirm(`Are you sure you want to withdraw Invoice #${invoice.id}? This will reverse all associated bills back to unbilled status.`)) return;

    invoice.actionInProgress = true;
    this.invoiceService.withdrawInvoice(invoice.id).then(response => {
      invoice.actionInProgress = false;
      if (response.success) {
        invoice.is_deleted = true;
        this.notyService.notify(response.message, 'success');
      } else {
        this.notyService.notify(response.message || 'Failed to withdraw invoice', 'error');
      }
    }).catch(error => {
      invoice.actionInProgress = false;
      this.notyService.notify('Error withdrawing invoice', 'error');
      console.error('Error withdrawing invoice:', error);
    });
  }
}
